var map = {
	"./1/courses/2/lessons/3.json": 2534
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2533;


//////////////////
// WEBPACK FOOTER
// ./src/services/API/fixtures/students ^\.\/.*\/courses\/2\/lessons\/3\.json$
// module id = 2533
// module chunks = 0